<!-- Page Title -->
<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-content text-white">
                    <h2>Impressum</h2>
                    <ul class="text-gray-200">
                        <li><a routerLink="/" class="hover:underline">Home</a></li>
                        <li>Impressum</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <div class="default-shape hidden md:block">
        <div class="shape-1"><img src="assets/img/shape/1.png" alt="shape" /></div>
        <div class="shape-2 rotateme"><img src="assets/img/shape/2.png" alt="shape" /></div>
        <div class="shape-3"><img src="assets/img/shape/3.svg" alt="shape" /></div>
        <div class="shape-4"><img src="assets/img/shape/4.svg" alt="shape" /></div>
        <div class="shape-5"><img src="assets/img/shape/5.png" alt="shape" /></div>
    </div>
</div>

<!-- Impressum Content -->
<section class="py-20 bg-white">
    <div class="container mx-auto px-4 max-w-4xl text-gray-800">
        <h2 class="text-3xl font-bold mb-6">Impressum</h2>

        <p class="mb-4">
            <strong>Tommys Fahrschule</strong><br>
            Bahnhofstraße 95<br>
            35390 Gießen
        </p>

        <p class="mb-4">
            <strong>Telefon:</strong> <a href="tel:+491771482503" class="text-blue-600">0177 - 148 250 3</a><br>
            <strong>Festnetz:</strong> <a href="tel:+4964120990375" class="text-blue-600">0641 - 209 903 75</a><br>
            <strong>E-Mail:</strong> <a href="mailto:info@tommys-fs.de" class="text-blue-600">info&commat;tommys-fs.de</a><br>
            <strong>Website:</strong> <a href="https://tommys-fs.de" target="_blank" class="text-blue-600">www.tommys-fs.de</a>
        </p>

        <h3 class="text-xl font-semibold mt-8 mb-2">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h3>
        <p class="mb-4">
            Tommys Fahrschule<br>
            Inhaber: Thomas<br>
            Bahnhofstraße 95<br>
            35390 Gießen
        </p>

        <h3 class="text-xl font-semibold mt-8 mb-2">Hosting</h3>
        <p class="mb-4">
            Unsere Website wird auf Servern in Deutschland gehostet. Die Datenverarbeitung erfolgt gemäß DSGVO.
        </p>
    </div>
</section>
<app-subscribe></app-subscribe>
